import { render, staticRenderFns } from "./shiftManagementMainDialogCreate.vue?vue&type=template&id=b0a74132"
import script from "./shiftManagementMainDialogCreate.vue?vue&type=script&lang=js"
export * from "./shiftManagementMainDialogCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports